export default {"src":"https://assets.ctr1.net/48f8efdb8b60/_next/static/media/c1-on-c1.cdc54079.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};